import { Directive, inject, input } from '@angular/core';
import { TimezoneService, LocaleService, FormComponent } from '@tdwb/core';

export class AgreementsBase {
  private readonly localeService = inject(LocaleService);

  language: string = this.localeService.getLanguage();
}

@Directive()
export class AgreementsDateBaseDirective extends AgreementsBase {
  readonly disabled = input(false);
  readonly consolidateAgreement = input(false);

  private readonly timezoneService = inject(TimezoneService);

  selectedAgreementEffectiveDate: Date = this.timezoneService.getCurrentDateInServerTimezone();

  trySubmit(form: FormComponent): boolean {
    form.maybeSubmitForm();
    return !form.formElement().invalid;
  }
}
